/**
 * Leitura do access token do Keycloak guardado no localStorage.
 *
 * O token da sessão já vale para todos os tenants do usuário: cada client em
 * `resource_access` é um tenant, com as roles dele. É essa lista que define
 * quais tenants aparecem na troca de tenant e quais são aceitos na
 * inicialização — sem depender de um novo login.
 */

/** Chave do access token no localStorage (ver `auth/keycloak/service.ts`). */
export const KEYCLOAK_ACCESS_TOKEN_KEY = 'kcAccessToken';

const decodeBase64Url = (value: string): string => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
  // Decodifica os bytes como UTF-8 (nomes e e-mails podem ter acentos).
  const percentEncoded = Array.from(
    atob(padded),
    (char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`,
  ).join('');
  return decodeURIComponent(percentEncoded);
};

/** Clients do Keycloak presentes em `resource_access` do access token. */
export const getTokenClients = (accessToken?: string | null): string[] => {
  if (!accessToken) {
    return [];
  }
  try {
    const payload = JSON.parse(decodeBase64Url(accessToken.split('.')[1]));
    return Object.keys(payload?.resource_access ?? {});
  } catch {
    return [];
  }
};

/** Access token guardado pela sessão atual, quando houver. */
export const getStoredAccessToken = (): string | null => {
  try {
    return localStorage.getItem(KEYCLOAK_ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
};

/** Clients do token guardado — usado antes da store existir. */
export const getStoredTokenClients = (): string[] =>
  getTokenClients(getStoredAccessToken());
